import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export function useGetOnboarding(userId: string) {
  return useQuery({
    queryKey: ["onboarding", userId],
    queryFn: () => api.getOnboarding(userId),
    enabled: !!userId,
  });
}
